import pulse from '@finn-no/pulse-sdk';
import { SearchVerticalConfig, type Vertical } from './config';

type Target = 'Listing' | 'Form';

// TR_ev01 - TR_ev09 (see tracking section in README.md)
export const trackSearchClick = (name, url, vertical, position, item, targetType: Target = 'Listing'): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Search',
        name: name,
        object: {
            // @ts-ignore id can only be string
            id: undefined, // set by Pulse SDK
            type: 'UIElement',
            elementType: 'Button',
            position,
            items: [item],
        },
        target: {
            id: url,
            type: targetType,
        },
        vertical: {
            name: 'travel',
            subVertical: vertical,
        },
    });
};

// Pulse tracker id: TR_pv01 - TR_pv05 (see tracking section in README.md)
export const trackBasicPageView = (vertical: Vertical): void => {
    let pulseVertical = '';
    let _url = '';

    switch (vertical) {
        case SearchVerticalConfig.flight.vertical:
            pulseVertical = 'flight';
            _url = SearchVerticalConfig.flight.fullPath;
            break;
        case SearchVerticalConfig.hotel.vertical:
            pulseVertical = 'hotel';
            _url = SearchVerticalConfig.hotel.fullPath;
            break;
        case SearchVerticalConfig.carrental.vertical:
            pulseVertical = 'car_rental';
            _url = SearchVerticalConfig.carrental.fullPath;
            break;
        case SearchVerticalConfig.prepackage.vertical:
            pulseVertical = 'prepackage';
            _url = SearchVerticalConfig.prepackage.fullPath;
            break;
        case SearchVerticalConfig.fhh.vertical:
            pulseVertical = 'holiday_rental';
            _url = SearchVerticalConfig.fhh.fullPath;
            break;
    }

    pulse.trackPageView({
        object: {
            type: 'MarketFrontpage',
            name: pulseVertical,
        },
        vertical: {
            name: 'travel',
            subVertical: pulseVertical,
        },
    });
};
